import React, { useState, useEffect, useContext } from "react";
import { C4FStatusContext, ReferenceDataContext } from "../main/App";
import { Dropdown, DropdownButton, Row, Col, Container, Table, Button, ButtonGroup } from 'react-bootstrap';
import config from "../etc/config.json";
import '../css/Profile.css';
import { getRuleDefinition, getRuleTypesForRuleset, getRuleNamesForRulesetAndType, getRuleset, getRuleTypeDescription, getRecurringEventByRulesetName, getFactorValue } from "../common/Helpers";
import C4FSimpleTable from "../common/C4FSimpleTable";


function C4FPrizeMoney(props) {
    const { raiseError } = useContext(C4FStatusContext);
    const { raceRulesets, raceEventRules, ruleTypes, recurringEvents, commonRaceRules } = useContext(ReferenceDataContext);
    const [refresh, doRefresh] = useState(0);
    const [prizeList, setPrizeList] = useState(null);
    const [ruleset, setRuleset] = useState('raceEdition' in props ? props.raceEdition.race.rulesetName : 'OneDayRaceStandard');
    const [ruleType, setRuleType] = useState('RaceReward');
    const [ruleName, setRuleName] = useState('Flat');
    const [showDetails, setShowDetails] = useState(false);
    const [numberOfStages, setNumberOfStages] = useState('raceEdition' in props ? props.raceEdition.race.numberOfStages : 1);
    const [c4fCategory, setC4fCategory] = useState('raceEdition' in props ? props.raceEdition.race.category : 2);
    const [numberOfTeams, setNumberOfTeams] = useState('raceEdition' in props ? props.raceEdition.numberOfParticipants : 10);
    const [ridersPerTeam, setRidersPerTeam] = useState('raceEdition' in props ? props.raceEdition.race.ridersPerTeam : 8);
    const [group, setGroup] = useState('raceEdition' in props ? props.raceEdition.group : 1);
    const [c4fPointsCategoryFactorStageRace, setCategoryPointsFactorStageRace] = useState(1);
    const [c4fPointsCategoryFactorStage, setCategoryPointsFactorStage] = useState(1);
    const [prizeMoneyCategoryFactorStage, setCategoryPrizeMoneyFactorStage] = useState(1);
    const [prizeMoneyCategoryFactorStageRace, setCategoryPrizeMoneyFactorStageRace] = useState(1);
    const [numberOfTeamsFactor, setNumberOfTeamsFactor] = useState(1);
    const [groupNumberFactor, setGroupNumberFactor] = useState(1);

    useEffect(() => {
        if (prizeList === null &&
            ruleset && ruleType && ruleName && numberOfStages && c4fCategory && numberOfTeams && ridersPerTeam && group)
            initialize();
    }, []);

    useEffect(() => {
        doRefresh(p => p + 1);
    }, [prizeList]);

    useEffect(() => {
        initialize();
        doRefresh(p => p + 1);
    }, [props.raceEdition]);

    function handleSetRuleset(newRulesetName) {
        // default to same rule type, if available or first rule type and first rule name
        let newRuleset = getRuleset(raceRulesets, newRulesetName);
        let newRuleTypes = getRuleTypesForRuleset(raceRulesets, newRulesetName);
        let newRuleType = newRuleTypes.includes(ruleType) ? ruleType : newRuleTypes[0];
        let newRuleNames = getRuleNamesForRulesetAndType(raceRulesets, newRulesetName, newRuleType);
        let newRuleName = newRuleNames.includes(ruleName) ? ruleName : newRuleNames[0];

        let newC4fCategory = c4fCategory;
        let newNumberOfStages = numberOfStages;
        let newRidersPerTeam = ridersPerTeam;
        let recurringEvent = getRecurringEventByRulesetName(recurringEvents, newRulesetName);
        if (recurringEvent) {
            if ('c4fCategory' in recurringEvent)
                newC4fCategory = recurringEvent.c4fCategory;
            if ('ridersPerTeam' in recurringEvent)
                newRidersPerTeam = recurringEvent.ridersPerTeam;
            if ('numberOfStages' in recurringEvent)
                newNumberOfStages = recurringEvent.numberOfStages;
            else {
                if (newRuleset.raceType === 'OneDayRace')
                    newNumberOfStages = 1;
                else
                    newNumberOfStages = 5;
            }
        }
        else {
            if ('defaultC4fCategory' in newRuleset)
                newC4fCategory = newRuleset.defaultC4fCategory;
            if ('defaultRidersPerTeam' in newRuleset)
                newRidersPerTeam = newRuleset.defaultRidersPerTeam;
            if (newRuleset.raceType === 'OneDayRace') {
                newNumberOfStages = 1;
            }
            else {
                if (newC4fCategory === 6) {
                    newC4fCategory = 5;
                }
                newNumberOfStages = 5;

            }
        }

        setRidersPerTeam(newRidersPerTeam)
        setNumberOfStages(newNumberOfStages);
        setC4fCategory(newC4fCategory);
        setRuleset(newRulesetName);
        setRuleType(newRuleType);
        setRuleName(newRuleName);
        handlePrizeList(newRulesetName, newRuleType, newRuleName, newC4fCategory, newNumberOfStages, numberOfTeams, newRidersPerTeam, group, showDetails);
    }

    function handleSetRuleType(newRuleType) {
        // default to same rule type, if available or first rule type and first rule name
        let newRuleNames = getRuleNamesForRulesetAndType(raceRulesets, ruleset, newRuleType);
        let newRuleName = newRuleNames.includes(ruleName) ? ruleName : newRuleNames[0];

        setRuleType(newRuleType);
        setRuleName(newRuleName);
        handlePrizeList(ruleset, newRuleType, newRuleName, c4fCategory, numberOfStages, numberOfTeams, ridersPerTeam, group, showDetails);
    }

    function handleSetRuleName(newRuleName) {
        handlePrizeList(ruleset, ruleType, newRuleName, c4fCategory, numberOfStages, numberOfTeams, ridersPerTeam, group, showDetails);
        setRuleName(newRuleName);
    }

    function handleSetCategory(newCategory) {
        handlePrizeList(ruleset, ruleType, ruleName, newCategory, numberOfStages, numberOfTeams, ridersPerTeam, group, showDetails);
        setC4fCategory(newCategory);
    }

    function handleSetNumberOfStages(newNumberOfStages) {
        handlePrizeList(ruleset, ruleType, ruleName, c4fCategory, newNumberOfStages, numberOfTeams, ridersPerTeam, group, showDetails);
        setNumberOfStages(newNumberOfStages);
    }

    function handleSetNumberOfTeams(newNumberOfTeams) {
        handlePrizeList(ruleset, ruleType, ruleName, c4fCategory, numberOfStages, newNumberOfTeams, ridersPerTeam, group, showDetails);
        setNumberOfTeams(newNumberOfTeams);
    }

    function handleSetRidersPerTeam(newRidersPerTeam) {
        handlePrizeList(ruleset, ruleType, ruleName, c4fCategory, numberOfStages, numberOfTeams, newRidersPerTeam, group, showDetails);
        setRidersPerTeam(newRidersPerTeam);
    }

    function handleSetGroup(newGroup) {
        handlePrizeList(ruleset, ruleType, ruleName, c4fCategory, numberOfStages, numberOfTeams, ridersPerTeam, newGroup, showDetails);
        setGroup(newGroup);
    }

    function handleSetShowDetails(newShowDetails) {
        handlePrizeList(ruleset, ruleType, ruleName, c4fCategory, numberOfStages, numberOfTeams, ridersPerTeam, group, newShowDetails);
        setShowDetails(newShowDetails);
    }

    function getWertungIconForRuleName(ruleName) {
        switch (ruleName) {
            case 'MountainCat1':
                return <img className="mb-1" src={config.DIR_ICONS + "wertung1.png"} alt="1" width="18" />;
            case 'MountainCat2':
                return <img className="mb-1" src={config.DIR_ICONS + "wertung2.png"} alt="2" width="18" />;
            case 'MountainCat3':
                return <img className="mb-1" src={config.DIR_ICONS + "wertung3.png"} alt="3" width="18" />;
            case 'MountainCat4':
                return <img className="mb-1" src={config.DIR_ICONS + "wertung4.png"} alt="4" width="18" />;
            case 'MountainCatHC':
                return <img className="mb-1" src={config.DIR_ICONS + "wertung5.png"} alt="HC" width="18" />;
            case 'IntermediateSprint':
                return <img className="mb-1" src={config.DIR_ICONS + "wertung6.png"} alt="S" width="18" />;
            case 'MountainCat1B':
                return <img className="mb-1" src={config.DIR_ICONS + "wertung7.png"} alt="1B" width="21" />;
            case 'MountainCat2B':
                return <img className="mb-1" src={config.DIR_ICONS + "wertung8.png"} alt="2B" width="21" />;
            case 'MountainCat3B':
                return <img className="mb-1" src={config.DIR_ICONS + "wertung9.png"} alt="3B" width="21" />;
            case 'MountainCat4B':
                return <img className="mb-1" src={config.DIR_ICONS + "wertung10.png"} alt="4B" width="21" />;
            case 'MountainCatHCB':
                return <img className="mb-1" src={config.DIR_ICONS + "wertung11.png"} alt="HCB" width="21" />;
            case 'IntermediateSprintB':
                return <img className="mb-1" src={config.DIR_ICONS + "wertung12.png"} alt="SB" width="21" />;
            case 'MountainCatHCC':
                return <img className="mb-1" src={config.DIR_ICONS + "wertung5.png"} alt="HCC" width="21" />;
            default: break;
        }
    }

    function initialize() {
        handlePrizeList(ruleset, ruleType, ruleName, c4fCategory, numberOfStages, numberOfTeams, ridersPerTeam, group, showDetails);
    }

    function handlePrizeList(rulesetName, ruleType, ruleName, c4fCategory, numberOfStages, numberOfTeams, ridersPerTeam, group, showDetails) {
        let ruleset = getRuleset(raceRulesets, rulesetName);
        let numberOfStagesFactor = ruleType === 'StageRaceReward' ? numberOfStages : 1;

        let rule = null;
        try {
            rule = getRuleDefinition(raceRulesets, raceEventRules, rulesetName, ruleType, ruleName);
        }
        catch (e) {
            raiseError(e);
            return;
        }

        let maxPositions = Math.min(Math.max(
            'c4fPoints' in rule ? rule.c4fPoints.length : 0,
            'c4fPointsBase' in rule ? rule.c4fPointsBase.length : 0,
            'c4fPointsPerStage' in rule ? rule.c4fPointsPerStage.length : 0,
            'sprintPoints' in rule ? rule.sprintPoints.length : 0,
            'mountainPoints' in rule ? rule.mountainPoints.length : 0,
            'prizeMoney' in rule ? rule.prizeMoney.length : 0,
            'prizeMoneyBase' in rule ? rule.prizeMoneyBase.length : 0,
            'prizeMoneyPerStage' in rule ? rule.prizeMoneyPerStage.length : 0,
            'bonusSeconds' in rule ? rule.bonusSeconds.length : 0),
            ridersPerTeam * numberOfTeams);

        let newPrizeList = [];
        if (maxPositions > 0)
            for (let position = 0; position < maxPositions; position++)
                newPrizeList.push({
                    c4fPoints: 'c4fPoints' in rule && rule.c4fPoints.length > position ? rule.c4fPoints[position] : 0,
                    c4fPointsBase: 'c4fPointsBase' in rule && rule.c4fPointsBase.length > position ? rule.c4fPointsBase[position] : 0,
                    c4fPointsPerStage: 'c4fPointsPerStage' in rule && rule.c4fPointsPerStage.length > position ? rule.c4fPointsPerStage[position] : 0,
                    sprintPoints: 'sprintPoints' in rule && rule.sprintPoints.length > position ? rule.sprintPoints[position] : 0,
                    mountainPoints: 'mountainPoints' in rule && rule.mountainPoints.length > position ? rule.mountainPoints[position] : 0,
                    prizeMoney: 'prizeMoney' in rule && rule.prizeMoney.length > position ? rule.prizeMoney[position] * numberOfStagesFactor : 0,
                    prizeMoneyBase: 'prizeMoneyBase' in rule && rule.prizeMoneyBase.length > position ? rule.prizeMoneyBase[position] : 0,
                    prizeMoneyPerStage: 'prizeMoneyPerStage' in rule && rule.prizeMoneyPerStage.length > position ? rule.prizeMoneyPerStage[position] : 0,
                    bonusSeconds: 'bonusSeconds' in rule && rule.bonusSeconds.length > position ? rule.bonusSeconds[position] : 0
                })

        let newPrizeListMetadata =
            []
                .concat(newPrizeList.some(prize => prize.c4fPoints > 0 && showDetails) ? [
                    { columnName: 'c4fPoints', columnDescription: 'C4F Points Base' },
                    { columnName: 'c4fPointsAdapted', columnDescription: 'C4F Points Adapted' }] : [])
                .concat(newPrizeList.some(prize => prize.c4fPoints > 0 && !showDetails) ? [
                    { columnName: 'c4fPointsAdapted', columnDescription: 'C4F Points' }] : [])
                .concat(newPrizeList.some(prize => (prize.c4fPointsBase > 0 || prize.c4fPointsPerStage > 0) && showDetails) ? [
                    { columnName: 'c4fPointsBase', columnDescription: 'C4F Points Base' },
                    { columnName: 'c4fPointsPerStage', columnDescription: 'C4F Points Per Stage' },
                    { columnName: 'c4fPointsTotal', columnDescription: 'C4F Points Total' },
                    { columnName: 'c4fPointsTotalAdapted', columnDescription: 'C4F Points Adapted' }] : [])
                .concat(newPrizeList.some(prize => (prize.c4fPointsBase > 0 || prize.c4fPointsPerStage > 0) && !showDetails) ? [
                    { columnName: 'c4fPointsTotalAdapted', columnDescription: 'C4F Points' }] : [])
                .concat(newPrizeList.some(prize => prize.prizeMoney > 0 && showDetails) ? [
                    { columnName: 'prizeMoney', columnDescription: 'Prize Money Base', columnType: 'currency' },
                    { columnName: 'prizeMoneyAdapted', columnDescription: 'Prize Money Adapted', columnType: 'highlightedCurrency' }] : [])
                .concat(newPrizeList.some(prize => prize.prizeMoney > 0 && !showDetails) ? [
                    { columnName: 'prizeMoneyAdapted', columnDescription: 'Prize Money', columnType: 'highlightedCurrency' }] : [])
                .concat(newPrizeList.some(prize => (prize.prizeMoneyBase > 0 || prize.prizeMoneyPerStage > 0) && showDetails) ? [
                    { columnName: 'prizeMoneyBase', columnDescription: 'Prize Money Base' },
                    { columnName: 'prizeMoneyPerStage', columnDescription: 'Prize Money Per Stage' },
                    { columnName: 'prizeMoneyTotal', columnDescription: 'Prize Money Total' },
                    { columnName: 'prizeMoneyTotalAdapted', columnDescription: 'Prize Money Adapted' }] : [])
                .concat(newPrizeList.some(prize => (prize.prizeMoneyBase > 0 || prize.prizeMoneyPerStage > 0) && !showDetails) ? [
                    { columnName: 'prizeMoneyTotalAdapted', columnDescription: 'Prize Money' }] : [])
                .concat(newPrizeList.some(prize => prize.sprintPoints > 0) ? [{ columnName: 'sprintPoints', columnDescription: 'Sprint' }] : [])
                .concat(newPrizeList.some(prize => prize.mountainPoints > 0) ? [{ columnName: 'mountainPoints', columnDescription: 'Mountain' }] : [])
                .concat(newPrizeList.some(prize => prize.bonusSeconds > 0) ? [{ columnName: 'bonusSeconds', columnDescription: 'Bonus Seconds' }] : []);

        let c4fPointsCategoryFactorStage = 1;
        let c4fPointsCategoryFactorStageRace = 1;
        let prizeMoneyCategoryFactorStage = 1;
        let prizeMoneyCategoryFactorStageRace = 1;
        let numberOfTeamsFactor = getFactorValue(commonRaceRules, 'NumberOfTeamsFactor', numberOfTeams, 1);
        let groupNumberFactor = getFactorValue(commonRaceRules, 'GroupNumberFactor', group);

        if (ruleset.raceType === 'OneDayRace') {
            c4fPointsCategoryFactorStage = getFactorValue(commonRaceRules, 'OneDayRaceRewardFactorC4FPoints', c4fCategory);
            prizeMoneyCategoryFactorStage = getFactorValue(commonRaceRules, 'OneDayRaceRewardFactorPrizeMoney', c4fCategory);

            newPrizeList = newPrizeList.map(entry => ({
                ...entry,
                c4fPointsAdapted: entry.c4fPoints * c4fPointsCategoryFactorStage * numberOfTeamsFactor * groupNumberFactor,
                prizeMoneyAdapted: entry.prizeMoney * prizeMoneyCategoryFactorStage * numberOfTeamsFactor
            }));
        }
        else {
            c4fPointsCategoryFactorStage = getFactorValue(commonRaceRules, 'StageRewardFactorC4FPoints', c4fCategory);
            c4fPointsCategoryFactorStageRace = getFactorValue(commonRaceRules, 'StageRaceRewardFactorC4FPoints', c4fCategory);
            prizeMoneyCategoryFactorStage = getFactorValue(commonRaceRules, 'StageRewardFactorPrizeMoney', c4fCategory);
            prizeMoneyCategoryFactorStageRace = getFactorValue(commonRaceRules, 'StageRaceRewardFactorPrizeMoney', c4fCategory);
            if (ruleType === 'RaceReward') {
                newPrizeList = newPrizeList.map(entry => ({
                    ...entry,
                    c4fPointsAdapted: entry.c4fPoints * c4fPointsCategoryFactorStage * numberOfTeamsFactor * groupNumberFactor,
                    prizeMoneyAdapted: entry.prizeMoney * prizeMoneyCategoryFactorStage * numberOfTeamsFactor
                }));
            }
            else if (ruleType === 'StageRaceReward') {
                newPrizeList = newPrizeList.map(entry => ({
                    ...entry,
                    c4fPointsTotal: entry.c4fPointsBase * c4fPointsCategoryFactorStageRace + entry.c4fPointsPerStage * numberOfStages,
                    c4fPointsTotalAdapted: (entry.c4fPointsBase * c4fPointsCategoryFactorStageRace + entry.c4fPointsPerStage * numberOfStages) * numberOfTeamsFactor * groupNumberFactor,
                    prizeMoneyTotal: (entry.prizeMoneyBase + entry.prizeMoneyPerStage * numberOfStages) * prizeMoneyCategoryFactorStageRace,
                    prizeMoneyTotalAdapted: (entry.prizeMoneyBase + entry.prizeMoneyPerStage * numberOfStages) * prizeMoneyCategoryFactorStageRace * numberOfTeamsFactor
                }));
            }
            else {
                newPrizeList = newPrizeList.map(entry => ({
                    ...entry,
                    c4fPointsAdapted: entry.c4fPoints * c4fPointsCategoryFactorStage * numberOfTeamsFactor * groupNumberFactor,
                    prizeMoneyAdapted: entry.prizeMoney * prizeMoneyCategoryFactorStage * numberOfTeamsFactor
                }));
            }
        }

        setCategoryPointsFactorStage(c4fPointsCategoryFactorStage);
        setCategoryPointsFactorStageRace(c4fPointsCategoryFactorStageRace);
        setCategoryPrizeMoneyFactorStage(prizeMoneyCategoryFactorStage);
        setCategoryPrizeMoneyFactorStageRace(prizeMoneyCategoryFactorStageRace);
        setNumberOfTeamsFactor(numberOfTeamsFactor);
        setGroupNumberFactor(groupNumberFactor);

        setPrizeList({
            metadata: newPrizeListMetadata,
            data: newPrizeList
        });
        doRefresh(p => p + 1)
    }

    return <Container fluid className="container-fluid">
        <Row className=" d-flex justify-content-center">
            <Col className="m-0 p-0" style={{ minWidth: 400, maxWidth: "80vw" }}>
                <Row className=" m-0 p-0">
                    <Col >
                        <h4>Race Prizes</h4>
                        {!('raceEdition' in props) ?
                            <p>Prize money and points depend on multiple factors. Below you can select the race category, the number of stages (1 for one-day-races), the group, the number of teams in the race and the number of riders per team. Based on your settings, the tables will show the distribution of prize money and points.</p>
                            : null}
                    </Col>
                </Row>
                <Row className=" m-0 p-0">
                    <Col style={{ textAlign: "center" }}>
                        <p><b>Race Type:</b>
                            <DropdownButton disabled={'raceEdition' in props} variant="outline-primary py-0" title={getRuleset(raceRulesets, ruleset).shortDescription}
                                onSelect={(newRuleset) => handleSetRuleset(newRuleset)}>
                                {raceRulesets.map(ruleset =>
                                    <Dropdown.Item eventKey={ruleset.name}>{ruleset.shortDescription}</Dropdown.Item>
                                )}
                            </DropdownButton>
                        </p>
                    </Col>
                    <Col style={{ textAlign: "center" }}>
                        <p><b>Rule Type:</b>
                            <DropdownButton variant="outline-primary py-0" title={getRuleTypeDescription(ruleTypes, ruleType).shortDescription}
                                onSelect={(newRuleType) => handleSetRuleType(newRuleType)}>
                                {getRuleTypesForRuleset(raceRulesets, ruleset).map(ruleType =>
                                    <Dropdown.Item eventKey={ruleType}>{getRuleTypeDescription(ruleTypes, ruleType).shortDescription}</Dropdown.Item>
                                )}
                            </DropdownButton>
                        </p>
                    </Col>
                    <Col style={{ textAlign: "center" }}>
                        <p><b>Rule:</b>
                            <DropdownButton variant="outline-primary py-0" title={ruleName}
                                onSelect={(newRuleName) => handleSetRuleName(newRuleName)}>
                                {getRuleNamesForRulesetAndType(raceRulesets, ruleset, ruleType).map(ruleName =>
                                    <Dropdown.Item eventKey={ruleName}>{getWertungIconForRuleName(ruleName)}{ruleName}</Dropdown.Item>
                                )}
                            </DropdownButton>
                        </p>
                    </Col>
                    <Col style={{ textAlign: "center" }}>
                        <p><b>Detailed Calc.:</b><br/>
                        <ButtonGroup>
                          <Button variant={(showDetails) ? 'primary py-0' : 'outline-primary py-0'} onClick={() => handleSetShowDetails(true)}>Yes</Button>
                          <Button variant={(!showDetails) ? 'primary py-0' : 'outline-primary py-0'} onClick={() => handleSetShowDetails(false)}>No</Button>
                        </ButtonGroup>
                        </p>
                    </Col>
                </Row>
                <Row className=" m-0 p-0">
                    <Col style={{ textAlign: "center" }}>
                        <p><b>Category:</b>
                            <DropdownButton disabled={'raceEdition' in props} variant="outline-primary py-0" title={c4fCategory}
                                onSelect={(newCategory) => handleSetCategory(newCategory)}>
                                {(getRuleset(raceRulesets, ruleset).raceType === 'OneDayRace' ? [1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 5]).map(category =>
                                    <Dropdown.Item eventKey={category}>{category}</Dropdown.Item>
                                )}
                            </DropdownButton>
                        </p>
                    </Col>
                    {getRuleset(raceRulesets, ruleset).raceType === 'StageRace' ?
                        <Col style={{ textAlign: "center" }}>
                            <p><b>Stages:</b>
                                <DropdownButton disabled={'raceEdition' in props} variant="outline-primary py-0" title={numberOfStages}
                                    onSelect={(newNumberOfStages) => handleSetNumberOfStages(newNumberOfStages)}>
                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24].map(numberOfStages =>
                                        <Dropdown.Item eventKey={numberOfStages}>{numberOfStages}</Dropdown.Item>
                                    )}
                                </DropdownButton>
                            </p>
                        </Col>
                        : null}
                    <Col style={{ textAlign: "center" }}>
                        <p><b>Group:</b>
                            <DropdownButton disabled={'raceEdition' in props} variant="outline-primary py-0" title={group}
                                onSelect={(newGroup) => handleSetGroup(newGroup)}>
                                {[1, 2, 3].map(group =>
                                    <Dropdown.Item eventKey={group}>{group}</Dropdown.Item>
                                )}
                            </DropdownButton>
                        </p>
                    </Col>
                    <Col style={{ textAlign: "center" }}>
                        <p><b>Teams:</b>
                            <DropdownButton disabled={'raceEdition' in props} variant="outline-primary py-0" title={numberOfTeams}
                                onSelect={(newNumberOfTeams, e) => handleSetNumberOfTeams(newNumberOfTeams)}>
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22].map((numberOfTeams) =>
                                    <Dropdown.Item eventKey={numberOfTeams}>{numberOfTeams}</Dropdown.Item>
                                )}
                            </DropdownButton>
                        </p>
                    </Col>
                    <Col style={{ textAlign: "center" }}>
                        <p><b>Riders/Team:</b>
                            <DropdownButton disabled={'raceEdition' in props} variant="outline-primary py-0" title={ridersPerTeam}
                                onSelect={(newRidersPerTeam, e) => handleSetRidersPerTeam(newRidersPerTeam)}>
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((ridersPerTeam) =>
                                    <Dropdown.Item eventKey={ridersPerTeam}>{ridersPerTeam}</Dropdown.Item>
                                )}
                            </DropdownButton>
                        </p>
                    </Col>
                </Row>
            </Col>
        </Row>
        {showDetails ?
        <Row className=" d-flex justify-content-center">
            <Col className="col-8">
                <Table className="table table-light table-striped mt-0 " size="sm">
                    <thead>
                        {getRuleset(raceRulesets, ruleset).raceType === 'StageRace' ?
                            <>
                                <th>Tour Points Factor</th>
                                <th>Stage Points Factor</th>
                                <th>Tour Prize Factor</th>
                                <th>Stage Prize Factor</th>
                            </>
                            :
                            <>
                                <th>Points Factor</th>
                                <th>Prize Factor</th>
                            </>
                        }
                        <th>Teams Factor</th>
                        <th>Group Factor</th>
                    </thead>
                    <tbody>
                        <tr>
                            {getRuleset(raceRulesets, ruleset).raceType === 'StageRace' ?
                                <td>{(Math.round(c4fPointsCategoryFactorStageRace * 100) / 100).toFixed(2)}</td>
                                : null}
                            <td>{(Math.round(c4fPointsCategoryFactorStage * 100) / 100).toFixed(2)}</td>
                            {getRuleset(raceRulesets, ruleset).raceType === 'StageRace' ?
                                <td>{(Math.round(prizeMoneyCategoryFactorStageRace * 100) / 100).toFixed(2)}</td>
                                : null}
                            <td>{(Math.round(prizeMoneyCategoryFactorStage * 100) / 100).toFixed(2)}</td>
                            <td>{(Math.round(numberOfTeamsFactor * 100) / 100).toFixed(2)}</td>
                            <td>{(Math.round(groupNumberFactor * 100) / 100).toFixed(2)}</td>
                        </tr>
                    </tbody>

                </Table>
            </Col>
        </Row>
        :
        <></>
        }
        <div className="d-flex justify-content-center">
            <div className="my-2" style={{ maxHeight: 400, minWidth: 400, maxWidth: "80vw"}}>
                {prizeList ?
                    <C4FSimpleTable key={'prizeList' + refresh}
                        indexColumn={true}
                        data={prizeList.data}
                        hideFilterButtons={true}
                        rowMetadata={prizeList.metadata}
                    />
                    : null}
            </div>
        </div>
    </Container>

}

export default C4FPrizeMoney;
